export default __webpack_public_path__ + "static/media/Tier_2.af4abc04.svg";